import { render, staticRenderFns } from "./notice-release.vue?vue&type=template&id=05cbda46&scoped=true&"
import script from "./notice-release.vue?vue&type=script&lang=js&"
export * from "./notice-release.vue?vue&type=script&lang=js&"
import style0 from "./notice-release.vue?vue&type=style&index=0&id=05cbda46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cbda46",
  null
  
)

export default component.exports